import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Div = styled.div`
  position: absolute;
  display: inline-block;
  font-size: 1rem;
  font-weight: 300;
  color: #ccc;
  border-radius: 0;
  border: none;
  width: 1.5rem;
  padding-top: 0.2rem;
  text-align: center;
`;

const InputSuffix = ({ inputSuffix }) => {
  if (!inputSuffix) {
    return null;
  }
  return <Div>{inputSuffix}</Div>;
};
InputSuffix.propTypes = {
  inputSuffix: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
InputSuffix.defaultProps = {
  inputSuffix: '',
};
export default InputSuffix;
